import { render, staticRenderFns } from "./GeneralSearch.vue?vue&type=template&id=23cc38a4&scoped=true&"
import script from "./GeneralSearch.vue?vue&type=script&lang=js&"
export * from "./GeneralSearch.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSearch.vue?vue&type=style&index=0&id=23cc38a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cc38a4",
  null
  
)

export default component.exports